import { memo, useMemo } from "react";
import { makeStyles } from "tss-react/mui";
import { MiButton, MiInternalDrawer } from "@miplatform/components";
import { BUTTON_VARIANTS, COLORS } from "@miplatform/constants";
import { mdiEmailOutline, mdiEyeOutline } from "@mdi/js";
import { useMediaQuery } from "@mui/material";
import { EmailForm } from "./EmailForm";
import { useEmailForm } from "./useEmailForm";

export const EmailFormDrawer = memo(
  ({
    open,
    entity,
    entityType,
    templateType,
    onCloseoutDrawerOpen,
    onClose,
  }) => {
    const { classes, theme } = useStyles();
    const viewModel = useEmailForm({
      open,
      entity,
      entityType,
      templateType,
      onCloseoutDrawerOpen,
      onClose: () => onClose(templateType),
    });
    const isMediumScreen = useMediaQuery(theme.breakpoints.down("xl"));
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("lg"));
    const drawerWidth = useMemo(() => {
      if (isSmallScreen) return 440;
      if (isMediumScreen) return 500;

      return 666;
    }, [isMediumScreen, isSmallScreen]);

    const { actions, recipient, title, color, handlePreviewOpen, handleClose } =
      viewModel;

    return (
      <MiInternalDrawer
        open={open}
        className={classes.drawer}
        leftIcon={mdiEmailOutline}
        width={drawerWidth}
        title={`To ${recipient}: ${title}`}
        headerStyle={{ backgroundColor: theme.palette[color].light }}
        headerContainerStyle={{ borderColor: theme.palette[color].dark }}
        onClose={handleClose}
        rightAction={
          <MiButton
            variant={BUTTON_VARIANTS.OUTLINED}
            color={COLORS.BLACK}
            size="small"
            className={classes.emailPreviewButton}
            startIcon={{ path: mdiEyeOutline, iconSize: 0.6 }}
            title="View Email Preview"
            onClick={handlePreviewOpen}
          />
        }
        actions={actions}
      >
        <EmailForm entityType={entityType} viewModel={viewModel} />
      </MiInternalDrawer>
    );
  }
);

const useStyles = makeStyles()((theme) => ({
  drawer: {
    borderLeft: `${theme.spacing(2)} solid ${theme.palette.grey.accent}`,
    boxSizing: "content-box",
    overflow: "auto",
  },
  emailPreviewButton: {
    padding: theme.spacing(0, 2),
    borderColor: theme.palette.common.black,
    borderRadius: theme.spacing(0.5),
    backgroundColor: theme.palette.common.white,
  },
}));
